import { render } from "./LayoutView.vue?vue&type=template&id=4e789021&scoped=true&ts=true"
import script from "./LayoutView.vue?vue&type=script&lang=ts"
export * from "./LayoutView.vue?vue&type=script&lang=ts"

import "./LayoutView.vue?vue&type=style&index=0&id=4e789021&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e789021"]])

export default __exports__